import { render } from "./layout2.vue?vue&type=template&id=8f57c196&scoped=true"
import script from "./layout2.vue?vue&type=script&lang=js"
export * from "./layout2.vue?vue&type=script&lang=js"

import "./layout2.vue?vue&type=style&index=0&id=8f57c196&lang=scss&scoped=true"
import "./layout2.vue?vue&type=style&index=1&id=8f57c196&lang=scss"
import "./layout2.vue?vue&type=style&index=2&id=8f57c196&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f57c196"]])

export default __exports__